import {SortOrder} from "@components/table/consts";
import {Minute} from "@intuitionrobotics/ts-common";
import {PackageManagerModule} from "@modules/package-manager/PackageManagerModule";
import {UnitInfo} from "@app-sp/app-shared/package-manager";
import {UserGroupTypes} from "@app/ir-q-app-common/types/units";

export enum Status {
    live = "live",
    error = "error",
    tabletOff = "tabletOff",
    somOff = "somOff",
    down = "down",
    manuallyOff = "manuallyOff",
    preInstall = "preInstall"
}

export type StatusMap = {
    [k in Status]: number
} & {
    total: number,
    category: string
}

export enum VersionStatus {
    sameVersions = "Same versions",
    noVersions = "No versions",
    noSomVersion = "No Som version",
    noTabletVersion = "No Tablet version",
    differentVersions = "Different versions",
}

export const dateOptions = [
    "All date",
    "Last 36 hours",
    "Last 48 hours",
    "Last 72 hours",
    "Last 7 days",
    "Last 14 days",
    "Last 30 days"
];

export const errorNoRuntimeStatus = "PI";
export const errorDiffVersion = "DF";
export const errorOptions = [
    "Error B",
    "Error C",
    "Error N",
    "Error A",
    "Error M",
    "Error V",
    "Error D",
    "Error U",
    "Error R",
    "Error " + errorNoRuntimeStatus,
    "Error " + errorDiffVersion
]

export const diskMemoryInUseOptions = [
    "More than 85% in use"
]

export const stricklandOptions = [
    "UP_AND_RUNNING",
    "WAITING_FOR_INTERNET",
    "UNINITIALIZED",
    "WAIT_FOR_WIFI_CREDENTIALS",
    "CONNECTING_TO_WIFI",
    "CONNECTING_TO_WIFI_FAILED",
    "CONNECTING_TO_WIFI_FAILED_AUTH",
    "WAITING_FOR_PEER_CONNECTION",
    "FORGET_ALL_SSIDS",
    "RESET_STRICKLAND_SETTINGS"
];

import icon__unpair_white from "@res/images/icon__unpair_white.svg";
import icon__chat from "@res/images/icon_chat.svg";
import icon__llmchat from "@res/images/icon__llmchat.svg";
import icon__unpair from "@res/images/icon__unpair.svg";
import icn_v_purple from "@res/images/icn_v_purple.svg";
import icon__eyeS from "@res/images/icon__eyeS.svg";
import icon__pencil from "@res/images/icon__pencil.svg";
import icon__redPencil from "@res/images/icon__redPencil.svg";
import icon__rightArrow from "@res/images/icon-arrowhead-dark-xl-right.svg";
import icon__leftArrow from "@res/images/icon-arrowhead-dark-xl-left.svg";

export {icon__unpair_white, icon__chat, icon__llmchat, icon__unpair, icn_v_purple, icon__eyeS, icon__pencil, icon__redPencil, icon__rightArrow, icon__leftArrow};


// export const devEnvs: string[] = [
//     UnitEnv.QA,
//     UnitEnv.Support,
//     UnitEnv.Refurbished,
//     UnitEnv.Dev,
//     UnitEnv.Disenrolled
// ];

export interface PageUnitsState {
    loading: boolean;
    page: number;
    statusFilters: { [key: string]: boolean };
    userGroupFilters: { [key: string]: boolean };
    filters: { [index: string]: string };
    selectedDateRange: { [index: string]: (string | { from: number, to: number }) }
    sortOrder: SortOrder;
    sortBy: string;
    batch: boolean;
    batchUnits: string[];
    checkAll: boolean;
    selectedFrozen?: string[]
    tableHeaderConfig: string[]
    dragItem?: number
    dragOverItem?: number,
    unitsType: UserGroupTypes
}

export const Timeout_RS = 2.5 * Minute;

export type MyTableRow = {
    category: string,
    live: number,
    error: number,
    tabletOff: number,
    somOff: number,
    down: number,
    manuallyOff: number,
    preInstall: number,
    total: number
}
export const installationOptions = ["partial",
    "tablet partial",
    "som partial",
    "complete"];

export const rcOptions = [
    "rc",
    "rc & manual",
    "no rc",
    "rc 10+ min",
    "s - rc not finished",
    "t - rc not finished"
];

export const getPMUnitConfig = (unitId: string, product: string): UnitInfo | undefined => PackageManagerModule.getUnit({unitId, product});

export const getAliasAndConfig = (unitId: string, product: string = "elliq") => {
    const pmUnit = getPMUnitConfig(unitId, product);
    let alias = "", config = "";
    if (pmUnit) {
        alias = pmUnit.aliasId ? PackageManagerModule.getAlias(pmUnit.aliasId)?.name.toLowerCase() : "";
        config = pmUnit.configId ? PackageManagerModule.getConfig(pmUnit.configId)?.name.toLowerCase() : "";
    }
    return {alias, aliasId: pmUnit?.aliasId, config, configId: pmUnit?.configId}
}

export const UnitIdentitiesType = ["activation", "pairing", "both"];

// Single source of truth lives in units-query-state (kept import-light for tests).
export {tableHeaderConfigInit} from "./units-query-state";
